import { Component, Input } from '@angular/core';

@Component({
  selector: 'preloader',
  templateUrl: './preloader.component.html',
  styleUrls: ['./preloader.component.sass']
})
export class PreloaderComponent {

  @Input() color: string;

  constructor() { }

}
